const parseHtmlLink = (s) => {
  let regex = /(<a.+?)(href)/gi;
    let replacer = (match, p1, p2, p3, offset, string) => {
      return `${p1}target="_blank rel="noopener" ${p2}`
    }
    return s.replace(regex, replacer)
}

export default parseHtmlLink;